(() => {
  if (window.__liliumChatBooted) return;
  window.__liliumChatBooted = true;

  const init = (scope = document) => {
    scope.querySelectorAll('[data-lilium-chat]').forEach((root) => {
      if (root.__liliumChatReady) return;
      root.__liliumChatReady = true;

      const launcher = root.querySelector('[data-chat-launcher]');
      const close = root.querySelector('[data-chat-close]');
      const panel = root.querySelector('[data-chat-panel]');
      const firstField = root.querySelector('input, textarea, button');

      const setOpen = (open) => {
        root.classList.toggle('is-open', open);
        launcher?.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel?.setAttribute('aria-hidden', open ? 'false' : 'true');
        if (open) window.setTimeout(() => firstField?.focus({ preventScroll: true }), 180);
      };

      launcher?.addEventListener('click', () => setOpen(!root.classList.contains('is-open')));
      close?.addEventListener('click', () => setOpen(false));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && root.classList.contains('is-open')) {
          setOpen(false);
          launcher?.focus();
        }
      });

      if (root.dataset.openOnLoad === 'true') setOpen(true);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
